// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__Nb8uZ","imageOverlay":"styles_imageOverlay__yaIGL","title":"styles_title__OeKGR"};